module.exports = __webpack_public_path__ + "img/payrollwarning.f61a4552.svg";